var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import EncryptUtils from '@popup/steem/utils/encrypt.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { BackgroundCommand } from 'src/reference-data/background-message-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
function getMk() {
    return LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
}
const login = (mk) => __awaiter(void 0, void 0, void 0, function* () {
    const encryptedAccounts = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACCOUNTS);
    const accounts = yield EncryptUtils.decryptToJson(encryptedAccounts, mk);
    return !!accounts;
});
function sendBackMk() {
    return __awaiter(this, void 0, void 0, function* () {
        chrome.runtime.sendMessage({
            command: BackgroundCommand.SEND_BACK_MK,
            value: yield getMk(),
        });
    });
}
function saveMk(newMk) {
    //  LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.__MK, newMk);
    LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.__MK, EncryptUtils.hashPassword(newMk));
}
function lock() {
    LocalStorageUtils.saveValueInSessionStorage(LocalStorageKeyEnum.IS_LOCKED, 'true');
    //  LocalStorageUtils.removeFromSessionStorage(LocalStorageKeyEnum.__MK);
}
const MkModule = {
    sendBackMk,
    saveMk,
    getMk,
    lock,
    login,
};
export default MkModule;
